import { buildUrl } from './build-url';
export const backgroundImage = (image, domain) => (image === null || image === void 0 ? void 0 : image.src)
    ? {
        backgroundImage: `url(${buildUrl(image.src, false, domain)})`,
    }
    : null;
//# sourceMappingURL=background-image.js.map